import {
defineCustomElement,
MediaRadioElement
} from "vidstack/elements";

defineCustomElement(MediaRadioElement);